import React from 'react';
import { GetServerSideProps } from 'next';
import { connect, useSelector } from 'react-redux';
import { useDecision } from '@optimizely/react-sdk';

import Page from '@noqo/clients/web/Page';
import PizzaMenuPage from '@/menu/pizza/PizzaMenu';
import CenteredContainer from '@/common/CenteredContainer';
import initializePage from '@/common/pageSetup';
import { ErrorPage } from '@/ErrorPage';
import { useMenuPizzaPage } from '@/menu/hooks/useMenuPizzaPage';
import { isNational } from '@/graphql/gqlDataManipulation';
import { NATIONAL } from '@/localization/constants';
import { RootState } from '@/rootStateTypes';

export interface PizzaProps {
  pizzaError: boolean;
  id: string | null;
}

const PizzaPage = ({ pizzaError, id }: PizzaProps) => {
  useMenuPizzaPage(id);

  if (pizzaError) {
    return <ErrorPage />;
  }

  return (
    <>
      <CenteredContainer>
        <PizzaMenuPage />
      </CenteredContainer>
    </>
  );
};

const Pizza = ({ id, pageID, pizzaError, storeNumber }: any): JSX.Element => {
  const [{ enabled: isPizzaNoqoEnabled }] = useDecision('fr-noqo-286-pizza-enabled-2');

  const isLocalizedOnRedux = useSelector((state: RootState): boolean => state.domain.localization.localizedStore !== NATIONAL);
  const isLocalizedOnServer = !isNational(storeNumber);
  const isLocalized = isLocalizedOnRedux || isLocalizedOnServer;

  if (isLocalized && isPizzaNoqoEnabled) {
    // TODO: NOQO - Ensure we handle promo codes and deeplinks to builder via menu/pizza?id={id} 
    return <Page slug={pageID} />; 
  }

  return <PizzaPage id={id} pizzaError={pizzaError} />
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
const mapStateToProps = (state: any) => ({
  pizzaError: state.presentational.gqlErrors.pizzaError
});

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  const { props } = await (initializePage(ctx, 'pizza') as any);

  return {
    props: {
      ...props
    }
  };
};

export default connect(mapStateToProps, {})(Pizza);
